import { useContext } from 'react';
import styled from 'styled-components';

import colors from 'styles/colors';
import fonts from 'styles/fonts';
import media from 'styles/media';
import sizes from 'styles/sizes';

import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { NO_RESULTS } from '../constants';

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: relative;
	padding: 100px ${sizes.gutter.small}px 0;

	${media.small`
    padding: 50px ${sizes.gutter.small}px 0;
  `}
`;

const NoResultsText = styled.p`
	font-family: ${fonts.primary.regular};
	font-size: 16px;
	line-height: 24px;
	color: ${colors.functional.black};
	margin-bottom: 35px;
	max-width: 545px;
	text-align: center;
`;

const ResetButton = styled.button`
	font-family: ${fonts.primary.bold};
	font-size: 14px;
	line-height: 17px;
	text-align: center;
	letter-spacing: 0.01em;
	color: ${colors.primary.ocean};
	border-bottom: 1px solid ${colors.primary.ocean};
	margin-left: 12px;
	margin-bottom: 10px;
`;

/**
 * Displayed when no results for current search filters applied
 */

export default function NoResults() {
	const { globalization, resetAllFilters } = useContext(CruiseSearchContext);

	const { filtersDictionary, generalDictionary } = globalization?.dictionaries || {};
	const { actionClearAll } = filtersDictionary;
	const { errorNoResults } = generalDictionary;

	return (
		<Wrapper data-testid="no-results-found-label" id={NO_RESULTS}>
			<NoResultsText>{errorNoResults}</NoResultsText>
			<ResetButton onClick={resetAllFilters}>{actionClearAll}</ResetButton>
		</Wrapper>
	);
}
